var _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 45.3536,
    y1: 0.353553,
    x2: 1.35355,
    y2: 44.3536,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 62.2254,
    y2: -0.5,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1 0)",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/CloseWhite.b331d68fbdd1efa0868221e9bfc46ba5.svg";
export { ForwardRef as ReactComponent };